import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../../scss/_newAndOld.scss';

// 套用新版 Footer
import { NewFooter } from '@trg/tlw-layout/custom-element';
export default class FooterSwitch extends Component {
  render() {
    return <NewFooter />
  }
}

FooterSwitch.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  getFooterData: PropTypes.func.isRequired,
};
